export default __webpack_public_path__ + "static/media/instagram.f5ef3733.png";